import { render, staticRenderFns } from "./ProductsListView.vue?vue&type=template&id=6c87827e&scoped=true&"
import script from "./ProductsListView.vue?vue&type=script&lang=js&"
export * from "./ProductsListView.vue?vue&type=script&lang=js&"
import style0 from "./ProductsListView.vue?vue&type=style&index=0&id=6c87827e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87827e",
  null
  
)

export default component.exports